import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaigncontact-form',
  templateUrl: './campaigncontact-form.component.html',
  styleUrls: ['./campaigncontact-form.component.css']
})
export class CampaigncontactFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
